<script>
export default {
    name: 'forkiss-confirm',

    props: {
        message: {
            type: String
        },
        show: {
            type: Boolean
        },
        cancelText: {
            type: String,
            default: '取消'
        },
        okText: {
            type: String,
            default: '确定'
        }
    },
    methods: {
        close() {
            this.$emit('close');
        },
        ok() {
            this.$emit('ok');
        }
    }
};
</script>

<template lang="pug">
.forkiss-confirm(v-show="show")
    .forkiss-confirm-mask
    .forkiss-confirm-container
        .forkiss-confirm-wrapper
            .forkiss-confirm-body {{message}}
            .forkiss-confirm-footer
                slot(name="footer")
                    .button-group
                        button.text-btn.cancel-btn(type="text",
                            data-touch="true",
                            @click="close") {{cancelText}}
                        button.text-btn.ok-btn(type="text",
                            data-touch="true",
                            @click="ok") {{okText}}
</template>

<style lang="less">
.forkiss-confirm {
    position: relative;
    color: #333;
    font-size: .28rem;

    .forkiss-confirm-mask {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: 999;
        background-color: rgba(0, 0, 0, .6);
    }
    .forkiss-confirm-container {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: 1000;

        .forkiss-confirm-wrapper {
            position: absolute;
            width: 5.4rem;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            background: #FFF;
            border-radius: .12rem;
        }
        .forkiss-confirm-body {
            padding: .48rem 0;
            text-align: center;
            color: #666;
        }

        .forkiss-confirm-footer {
            text-align: center;

            .button-group {
                display: flex;
                border-top: 1px solid #b1b1b1;
            }
            .text-btn {
                flex: 1;
                height: .9rem;
                line-height: .9rem;
                border: none;
                outline: none;
                background: #FFF;
                font-size: .28rem;
                color: #333;

                & + .text-btn {
                    border-left: 1px solid #b1b1b1;
                }

                &:first-child {
                    border-bottom-left-radius: .1rem;
                }

                &:last-child {
                    border-bottom-right-radius: .1rem;
                }
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/confirm.vue